// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"2194":"reactTeaserSlider","4968":"reactGallery04","9792":"reactTeaserList01"}[chunkId] || chunkId) + "." + {"2194":"194bc1f5","4968":"b1caf51e","6031":"8e3d15c7","9792":"b1caf51e"}[chunkId] + ".chunk.css";
};